/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConsigneeDeliveryNoteBundlesArrayResponseV3 } from '../models/consignee-delivery-note-bundles-array-response-v-3';
import { getConsigneeAddonsDeliveryNoteBundlesV3 } from '../fn/delivery-note-bundles-v-3/get-consignee-addons-delivery-note-bundles-v-3';
import { GetConsigneeAddonsDeliveryNoteBundlesV3$Params } from '../fn/delivery-note-bundles-v-3/get-consignee-addons-delivery-note-bundles-v-3';

@Injectable({ providedIn: 'root' })
export class DeliveryNoteBundlesV3Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConsigneeAddonsDeliveryNoteBundlesV3()` */
  static readonly GetConsigneeAddonsDeliveryNoteBundlesV3Path = '/organization-sites/{organizationSiteKey}/consignee/delivery-note-bundles/';

  /**
   * Get consignee delivery note bundles (v3).
   *
   * Get delivery note bundles for consignee with enhanced pagination and sorting.
   * Wraps the basic backend endpoint and enriches each bundle with a qsStatus
   * (traffic light) aggregated from its delivery notes' article comparison statuses.
   * All filters (filterProperty/filterValue, direct field filters, search) are
   * passed through to the basic backend.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeAddonsDeliveryNoteBundlesV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsDeliveryNoteBundlesV3$Response(params: GetConsigneeAddonsDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeDeliveryNoteBundlesArrayResponseV3>> {
    const obs = getConsigneeAddonsDeliveryNoteBundlesV3(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get consignee delivery note bundles (v3).
   *
   * Get delivery note bundles for consignee with enhanced pagination and sorting.
   * Wraps the basic backend endpoint and enriches each bundle with a qsStatus
   * (traffic light) aggregated from its delivery notes' article comparison statuses.
   * All filters (filterProperty/filterValue, direct field filters, search) are
   * passed through to the basic backend.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeAddonsDeliveryNoteBundlesV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeAddonsDeliveryNoteBundlesV3(params: GetConsigneeAddonsDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<ConsigneeDeliveryNoteBundlesArrayResponseV3> {
    const resp = this.getConsigneeAddonsDeliveryNoteBundlesV3$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConsigneeDeliveryNoteBundlesArrayResponseV3>): ConsigneeDeliveryNoteBundlesArrayResponseV3 => r.body)
    );
  }

}
